import Stack from "@mui/material/Stack";
import { MainText } from "../data/style/Style";

const Statistics = () => {
  return (
    <Stack>
      <MainText>Half page athletes statistics</MainText>
      <MainText>Half page weekly workout list</MainText>
    </Stack>
  );
};

export default Statistics;
